module.exports = __webpack_public_path__ + "assets/img/title-257dec8b.png";